import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { nullSafe } from 'Utility/globalMethods';
import { portalModalSelector } from 'Store/selectors';
import { goPopup } from 'Store/actions/portalModalActions';
import * as actionLayer from '../../modules/CustomerCareActions';
import DeleteCustomerCarePopup from './DeleteCustomerCarePopup';

const mapDispatchToProps = (dispatch) => ({
	deleteItem: (item) => dispatch(actionLayer.deleteCustomerCareUser.request(item)),
	closeModal: () => dispatch(goPopup('')),
	fetchCustomerCareList: (pageSize, pageNumber) => {
		dispatch(
			actionLayer.fetchCustomerCareList.request({
				size: pageSize,
				pageNumber,
				userId: '',
				username: '',
				email: '',
				phone: '',
				groupId: '',
			})
		);
	},
	...bindActionCreators(actionLayer, dispatch),
});

const mapStateToProps = (state) => ({
	isLoading: nullSafe(() => state.CustomerCare.isLoading, false),
	status: nullSafe(() => portalModalSelector(state).data.payload.status, ''),
	payload: nullSafe(() => portalModalSelector(state).data.payload, {}),
});

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps) => ({
	...stateProps,
	actions: dispatchProps,
}))(DeleteCustomerCarePopup);
